import { useQuery } from '@tanstack/react-query';

import { getGlobalSettings } from '@shared/api/globalSettings';
import { BOOK_A_CALL_HREF, SUPPORT_EMAIL } from '@shared/constants';

// The current hardcoded values, used as placeholder + fallback so the UI renders
// instantly, never blanks, and keeps working unauthenticated or if the fetch
// fails. bookAMeetingUrl is coalesced to non-null for callers that need an href.
const FALLBACK = {
  supportEmails: [SUPPORT_EMAIL] as string[],
  bookAMeetingUrl: BOOK_A_CALL_HREF
};

interface GlobalSettingsValue {
  supportEmails: string[];
  supportEmail: string;
  bookAMeetingUrl: string;
}

export const useGlobalSettings = (): GlobalSettingsValue => {
  const { data } = useQuery({
    queryKey: ['global-settings'],
    queryFn: getGlobalSettings,
    staleTime: 5 * 60 * 1000,
    placeholderData: FALLBACK
  });

  const supportEmails =
    data?.supportEmails && data.supportEmails.length > 0
      ? data.supportEmails
      : FALLBACK.supportEmails;

  return {
    supportEmails,
    supportEmail: supportEmails[0],
    bookAMeetingUrl: data?.bookAMeetingUrl ?? FALLBACK.bookAMeetingUrl
  };
};
